exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FinishConceptModal-module__content-wrapper___2BNG6 img{max-width:200px;margin:0 auto 1rem;display:flex;justify-content:center}.FinishConceptModal-module__content-wrapper___2BNG6 h2{margin-bottom:1rem}.FinishConceptModal-module__content-wrapper___2BNG6 strong{display:block}.FinishConceptModal-module__content-wrapper___2BNG6 p{margin-bottom:.75rem}.FinishConceptModal-module__content-wrapper___2BNG6 p a{color:#0827e9;cursor:pointer}.FinishConceptModal-module__content-wrapper___2BNG6 .FinishConceptModal-module__button-wrapper___2V-cq{margin-top:2rem;display:grid;grid-auto-flow:column;gap:.5rem;justify-content:end}", ""]);

// exports
exports.locals = {
	"content-wrapper": "FinishConceptModal-module__content-wrapper___2BNG6",
	"button-wrapper": "FinishConceptModal-module__button-wrapper___2V-cq"
};